<div id="no-access-dialog">
  <div id="no-access-header"><h3>Something Is Wrong with Your Access</h3></div>
  <div id="no-access-content">
    Looks like you don't have access to <span id="no-access-member">{{memberName}}</span>, please switch to a different member or contact CPSC support team: <a id="email-link" (mousedown)="email()">cpscsupport@vizientinc.com</a> for assistance. Thank you.
  </div>
  <div id="no-access-buttons">
    <button id="ok-button" mat-raised-button (click)="confirm()">OK</button>
  </div>
</div>
